import React from 'react'

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import { makeStyles, CircularProgress } from '@material-ui/core'

import MomentUtils from '@date-io/moment'
import moment from 'moment'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

import { extractDayRange } from '../utils/extractDate'
import { roles } from '../utils/constants'
import Modal from '../components/modal/Modal'
import RoomDetailsView from '../components/view/RoomDetailsView'
import {
  deleteChat,
  getChatsThunk,
  getChatById,
  createMessageRSPA,
  editMessageRSPA,
  deleteMessageRSPA,
  getMessagesRSPA,
  getInterventionMessagesRSPA,
  getRoomsRSPA,
  createChatRSPA,
  clearPrivateRooms,
  clearGroupRooms,
  clearMediationRooms,
  clearArchivedRooms,
  exportMessagesRSPA,
  editRoomRSPA,
  updateGroupRoomReducer
} from '../store/chats/actions'
import { showAlertMessage } from '../store/alert/actions'
import StyledSVG from '../components/shared/StyledSVG'
import Button from '../components/button/Button'

import emptyMessageSVG from '../assets/icons/illustration-meditation-relaxed-person.svg'
import initialBannerSVG from '../assets/icons/messages-initial-ilustrator.svg'
import CalendarSVG from '../assets/icons/calendar.svg'
// import groupMessageSVG from '../assets/icons/message-group.svg'

import CreateChatForm from '../components/form/CreateChatForm'
import MessageComponent from '../components/messages/Messages'
import ModerationComponent from '../components/messages/ModerationMessages'
import ArchivedMessages from '../components/messages/ArchivedMessages'
import SidebarMessages from '../components/messages/SidebarMessages'
import {
  setRoomMenuDestination,
  setRoomMenuType,
  setArchivedType
} from '../store/room_menu/actions'
// import TabNavigation from '../components/shared/TabNavigation'
import featureFlags from '../featureFlag/featureFlags'

const useStyles = makeStyles(theme => ({
  root: {
    width: '98%',
    height: '87vh',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    fontFamily: 'Montserrat, Source Sans Pro',
    display: 'flex',
    flexWrap: 'nowrap'
  },
  menu_grid: {
    height: '100%',
    overflow: 'hidden'
  },
  main_content_grid: {
    height: '100%'
  },
  messages_menu: {
    position: 'relative',
    padding: '25px 15px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  empty_messages: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    '& h1': {
      fontWeight: 600,
      fontSize: 32,
      width: 400,
      textAlign: 'center',
      color: '#386093'
    }
  },
  main_content: {
    width: '98%',
    height: '100%',
    borderLeft: '1px solid rgba(173, 184, 204, 0.5)',
    borderRight: '1px solid rgba(173, 184, 204, 0.5)',
    [theme.breakpoints.down('1200')]: {
      width: '100%',
      borderRight: 'none'
    }
  },
  initial_banner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    '& h1': {
      textAlign: 'center',
      margin: 0,
      fontWeight: 700,
      fontSize: 32,
      color: '#386093',
      width: 800,
      [theme.breakpoints.down('1400')]: {
        width: 400,
        fontSize: 25
      },
      [theme.breakpoints.down('990')]: {
        fontSize: 20
      },
      [theme.breakpoints.down('814')]: {
        fontSize: 17,
        width: 350
      },
      [theme.breakpoints.down('765')]: {
        fontSize: 15,
        width: 200
      }
    },
    '& span': {
      textAlign: 'center',
      margin: 0,
      fontWeight: 400,
      fontSize: 24,
      color: '#386093',
      width: 600,
      [theme.breakpoints.down('1400')]: {
        width: 400,
        fontSize: 20
      },
      [theme.breakpoints.down('990')]: {
        fontSize: 15
      },
      [theme.breakpoints.down('814')]: {
        fontSize: 13
      },
      [theme.breakpoints.down('765')]: {
        width: 200
      }
    },
    '& .imgBanner': {
      display: 'flex',
      width: '500px',
      justifyContent: 'center',
      [theme.breakpoints.down('1400')]: {
        width: '450px'
      },
      [theme.breakpoints.down('990')]: {
        width: '360px'
      },
      [theme.breakpoints.down('878')]: {
        width: '330px'
      },
      [theme.breakpoints.down('814')]: {
        width: '300px'
      },
      [theme.breakpoints.down('765')]: {
        width: '250px'
      },
      [theme.breakpoints.down('672')]: {
        width: '200px'
      },
      [theme.breakpoints.down('600')]: {
        width: '250px'
      }
    }
  },
  message_component: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rootClass: {
    transition: 'width 0.5s ease-in-out',
    width: '70% !important'
  },
  room_details: {
    overflow: 'hidden',
    height: '100%',
    transition: 'width 0.5s ease-in-out'
  },
  room_detail_closed: {
    width: 0
  },
  room_detail_open: {
    width: '30%'
  },
  resize: {
    width: 6,
    cursor: 'col-resize',
    background: 'transparent'
  },
  export_modal: {
    '& .modal_title': {
      fontWeight: 700,
      fontSize: 20,
      color: '#386093'
    }
  },
  input_date: {
    marginTop: 32,
    '& h1': {
      fontSize: 18,
      fontWeight: 500,
      margin: 0
    },
    '& div.MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '48px',
      paddingLeft: 0,
      [theme.breakpoints.down('426')]: {
        height: '35px'
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #ADB8CC'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #ADB8CC'
      },
      '& input': {
        minWidth: 'auto',
        '&:-webkit-autofill,input:-webkit-autofill:focus': {
          transition: 'background-color 600000s 0s, color 600000s 0s'
        }
      },
      '& .MuiInputAdornment-positionEnd': {
        width: 24,
        '& .MuiIconButton-root': {
          padding: '10px 7px'
        }
      }
    },
    '& div.MuiFormControl-marginNormal': {
      margin: 0,
      width: '100%',
      [theme.breakpoints.down('426')]: {
        width: 255
      }
    },
    '& fieldset': {
      border: '1px solid #ADB8CC'
    },
    '&.MuiPickersCalendarHeader-dayLabel': {
      color: theme.palette.secondary.main
    },
    '& input:-internal-autofill-selected': {
      background: 'none'
    }
  },
  btns_modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    marginTop: 36
  },
  root_btn_modal: {
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19.5px',
    textTransform: 'none !important'
  },
  cancel_btn: {
    border: '1px solid #EF7C8F',
    color: '#EF7C8F',
    '&:hover': {
      border: '1px solid #EF7C8F'
    }
  },
  confirm_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 165,
    '&:hover': {
      backgroundColor: '#386093'
    }
  },
  circularProgressWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const NewMessagesPage = ({
  componentAttribute,
  match,
  getChats,
  currentUser,
  rooms_reducer,
  currentRoom,
  getChatById,
  createMessageRSPA,
  editMessageRSPA,
  deleteMessageRSPA,
  getMessagesRSPA,
  getInterventionMessagesRSPA,
  showAlertMessage,
  getRoomsRSPA,
  userOccupations,
  createChatRSPA,
  private_rooms,
  school_config,
  group_rooms,
  mediation_rooms,
  archived_rooms,
  clearPrivateRooms,
  clearGroupRooms,
  clearMediationRooms,
  clearArchivedRooms,
  deleteChat,
  room_menu,
  setRoomMenuDestination,
  setRoomMenuType,
  setArchivedType,
  exportMessagesRSPA,
  editRoomRSPA,
  updateGroupRoomReducer,
  isFetchingRoom
}) => {
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const canManageRooms = isAdmin && currentUser?.attributes?.can_manage_rooms
  const classes = useStyles()
  const [roomDetails, setRoomDetails] = React.useState({
    isOpen: false,
    attributes: {}
  })
  const history = useHistory()
  const [schoolChat, setSchoolChat] = React.useState({
    bool: false,
    name: '',
    mediation: null
  })
  const [showGroupForm, setShowGroupForm] = React.useState(false)
  const [showPrivateForm, setShowPrivateForm] = React.useState(false)
  const [showModerationSection, setShowModerationSection] = React.useState(
    false
  )
  const [showArchivedSection, setShowArchivedSection] = React.useState(false)

  const sidebarRef = React.useRef(null)
  const [sidebarWidth, setSidebarWidth] = React.useState(400)
  const startXRef = React.useRef(0)
  const startWidthRef = React.useRef(0)
  const frameIdRef = React.useRef(null)
  const [exportModal, setExportModal] = React.useState({
    open: false,
    startDate: moment(new Date()).format('YYYY-MM-DD'),
    endDate: moment(new Date()).format('YYYY-MM-DD')
  })
  const [dateErrors, setDateErrors] = React.useState(null)
  const archiveRoomsFeatureFlag = featureFlags.archiveRoomsFeature

  const startResizing = e => {
    e.preventDefault()

    startXRef.current = e.clientX
    startWidthRef.current = sidebarWidth

    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'

    document.addEventListener('mousemove', resize)
    document.addEventListener('mouseup', stopResizing)
  }

  const resize = e => {
    const delta = e.clientX - startXRef.current
    const minWidth = 400
    const maxWidth = 450
    const rawWidth = startWidthRef.current + delta
    const newWidth = Math.min(maxWidth, Math.max(minWidth, rawWidth))

    // Throttle do setState para não re-renderar a cada pixel
    if (frameIdRef.current) cancelAnimationFrame(frameIdRef.current)
    frameIdRef.current = requestAnimationFrame(() => {
      if (sidebarRef.current) {
        sidebarRef.current.style.width = `${newWidth}px`
      }
      setSidebarWidth(newWidth)
    })
  }

  const stopResizing = () => {
    if (frameIdRef.current) cancelAnimationFrame(frameIdRef.current)

    document.removeEventListener('mousemove', resize)
    document.removeEventListener('mouseup', stopResizing)

    document.body.style.cursor = ''
    document.body.style.userSelect = ''
  }

  const clearAllRooms = () => {
    clearPrivateRooms()
    clearGroupRooms()
    clearMediationRooms()
  }

  const handleCloseModerationSection = () => {
    setShowModerationSection(false)
  }

  const handleCloseArchivedSection = () => {
    setShowArchivedSection(false)
  }

  const handleClosePrivateForm = () => {
    setShowPrivateForm(false)
  }

  const handleCloseGroupForm = () => {
    setShowGroupForm(false)
  }

  const handleCloseMainSections = () => {
    handleCloseArchivedSection()
    handleCloseModerationSection()
  }

  const handleUnselectForms = () => {
    handleClosePrivateForm()
    handleCloseGroupForm()
  }

  const handleOpenExportModal = () => {
    setExportModal(prev => ({ ...prev, open: true }))
  }

  const handleCloseExportModal = () => {
    setExportModal(prev => ({ ...prev, open: false }))
  }

  const handleChangeDestination = destination => {
    if (destination === 0 && room_menu.current_room_type === 2) {
      setRoomMenuType(1)
    }
    setRoomMenuDestination(destination)
    handleCloseMainSections()
    clearAllRooms()
    getChats({
      page: 1
    })
  }

  const handleClickRoom = id => {
    handleCloseMainSections()
    history.push(`/rooms/${id}`)
  }

  const handleMainContent = () => {
    if (showPrivateForm || showGroupForm) {
      return (
        <CreateChatForm
          handleUnselectForms={handleUnselectForms}
          isDirectMsg={showPrivateForm}
          isGroupMsg={showGroupForm}
        />
      )
    } else if (showModerationSection) {
      return (
        <ModerationComponent
          history={history}
          handleCloseModerationSection={handleCloseModerationSection}
          roomsReducer={rooms_reducer}
          getRooms={getChats}
        />
      )
    } else if (showArchivedSection) {
      return (
        <ArchivedMessages
          history={history}
          archivedRoomType={room_menu.archived_section.room_type}
          setArchivedType={setArchivedType}
          currentUser={currentUser}
          roomsReducer={rooms_reducer}
          getRooms={getChats}
          handleCloseArchivedSection={handleCloseArchivedSection}
        />
      )
    } else {
      if (!isEmpty(currentRoom) && match?.params?.chatId) {
        return (
          <div className={classes.message_component}>
            <MessageComponent
              getRoomsRSPA={getRoomsRSPA}
              schoolConfig={school_config}
              rootClass={roomDetails.isOpen ? classes.rootClass : ''}
              setRoomDetails={setRoomDetails}
              history={history}
              createChatRSPA={createChatRSPA}
              isAdmin={isAdmin}
              schoolChat={schoolChat}
              showAlertMessage={showAlertMessage}
              createMessageRSPA={createMessageRSPA}
              editMessageRSPA={editMessageRSPA}
              deleteMessageRSPA={deleteMessageRSPA}
              getInterventionMessagesRSPA={getInterventionMessagesRSPA}
              getMessagesRSPA={getMessagesRSPA}
              currentUser={currentUser}
              currentRoom={currentRoom}
            />
            <div
              className={`${classes.room_details} ${
                roomDetails.isOpen
                  ? classes.room_detail_open
                  : classes.room_detail_closed
              }`}
            >
              <RoomDetailsView
                archiveRoomsFeatureFlag={archiveRoomsFeatureFlag}
                editRoomRSPA={editRoomRSPA}
                updateGroupRoomReducer={updateGroupRoomReducer}
                canManageRooms={canManageRooms}
                deleteChat={deleteChat}
                currentUser={currentUser}
                showAlertMessage={showAlertMessage}
                setRoomDetails={setRoomDetails}
                isAdmin={isAdmin}
                currentRoom={currentRoom}
              />
            </div>
          </div>
        )
      } else if (isFetchingRoom) {
        return (
          <div className={classes.circularProgressWrapper}>
            <CircularProgress />
          </div>
        )
      } else {
        if (
          group_rooms?.items?.length < 1 &&
          private_rooms?.items?.length < 1 &&
          mediation_rooms?.items?.length < 1
        ) {
          return (
            <div className={classes.empty_messages}>
              <img className='imgBanner' src={emptyMessageSVG} />
              <h1>Ainda não há mensagens por aqui!</h1>
            </div>
          )
        } else {
          return (
            <div className={classes.initial_banner}>
              <img className='imgBanner' src={initialBannerSVG} />
              <h1>Bem-vindo(a) à sua central de mensagens!</h1>
              <span>
                Selecione uma conversa para visualizar<br /> seu histórico ou
                inicie uma nova conversa.
              </span>
            </div>
          )
        }
      }
    }
  }

  const handleChangeDate = (date, inputName) => {
    if (date === null) {
      setExportModal(prev => ({ ...prev, [inputName]: null }))
    } else if (moment.isMoment(date)) {
      setExportModal(prev => ({
        ...prev,
        [inputName]: moment(date).format('YYYY-MM-DD')
      }))
    }
  }

  const handleConfirmExport = async () => {
    await exportMessagesRSPA({
      start_date: extractDayRange(exportModal.startDate).beginningOfDay,
      end_date: extractDayRange(exportModal.endDate).endOfDay
    })
      .then(res => {
        const url = window.URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `mensagens_${exportModal.startDate}_${exportModal.endDate}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        showAlertMessage(
          'Relatório de mensagens gerado com sucesso.',
          'success'
        )
      })
      .catch(error => {
        console.error(error)
        showAlertMessage('Falha ao exportar relatório de mensagens.', 'error')
      })
      .finally(() => {
        handleCloseExportModal()
      })
  }

  const handleClickOptions = optNumber => {
    switch (optNumber) {
      case 0:
        setShowPrivateForm(prev => {
          handleCloseGroupForm()
          handleCloseMainSections()
          return !prev
        })
        break
      case 1:
        setShowGroupForm(prev => {
          handleClosePrivateForm()
          handleCloseMainSections()
          return !prev
        })
        break
      case 2:
        setShowModerationSection(prev => {
          handleUnselectForms()
          handleCloseArchivedSection()
          return !prev
        })
        break
      case 3:
        setShowArchivedSection(prev => {
          handleUnselectForms()
          handleCloseModerationSection()
          return !prev
        })
        break
      default:
        break
    }
  }

  React.useEffect(() => {
    return () => {
      clearAllRooms()
    }
  }, [])

  React.useEffect(
    () => {
      if (match?.params?.chatId) {
        getChatById(match.params.chatId)
      }
    },
    [match?.params?.chatId]
  )

  React.useEffect(
    () => {
      if (currentRoom?.id && match?.params?.chatId) {
        const name = `${currentRoom?.room_participants?.[0]?.user?.name} + ${
          currentRoom?.room_participants?.[1]?.user?.name
        }`
        setSchoolChat({
          bool: !currentRoom?.room_participants
            ?.map(item => +item?.user?.fractal_id)
            .includes(+currentUser.attributes.fractal_id),
          name,
          mediation:
            currentRoom?.mediation_message_id &&
            currentRoom.room_type === 'group'
        })
      }
    },
    [currentRoom]
  )

  return (
    <Grid className={classes.root} container>
      <Grid
        className={classes.menu_grid}
        item
        ref={sidebarRef}
        style={{
          width: sidebarWidth
        }}
      >
        <div className={classes.messages_menu}>
          <SidebarMessages
            clearPrivateRooms={clearPrivateRooms}
            clearGroupRooms={clearGroupRooms}
            clearMediationRooms={clearMediationRooms}
            handleOpenExportModal={handleOpenExportModal}
            getChats={getChats}
            handleChangeDestination={handleChangeDestination}
            roomMenu={room_menu}
            setRoomMenuType={setRoomMenuType}
            roomsReducer={rooms_reducer}
            handleClickRoom={handleClickRoom}
            match={match}
            currentUser={currentUser}
            handleClickOptions={handleClickOptions}
            getRoomsRSPA={getRoomsRSPA}
            isAdmin={isAdmin}
          />
        </div>
      </Grid>
      <div onMouseDown={startResizing} className={classes.resize} />
      <Grid className={classes.main_content_grid} item style={{ flex: 1 }}>
        <div className={classes.main_content}>{handleMainContent()}</div>
      </Grid>
      <Modal
        open={exportModal.open}
        handleClose={() => handleCloseExportModal()}
      >
        <div className={classes.export_modal}>
          <h1 className='modal_title'>Informe um intervalo de tempo </h1>
          <MuiPickersUtilsProvider
            libInstance={moment}
            utils={MomentUtils}
            locale={'pt-br'}
          >
            <div className={classes.input_date}>
              <h1>Data inicial</h1>
              <KeyboardDatePicker
                variant='inline'
                disableToolbar
                maxDate={new Date()}
                maxDateMessage='A data deve ser inferior ao dia atual.'
                autoOk
                inputVariant='outlined'
                invalidDateMessage='Data inválida.'
                InputAdornmentProps={{ position: 'start' }}
                format='DD/MM/yyyy'
                margin='normal'
                value={
                  exportModal.startDate ? moment(exportModal.startDate) : null
                }
                onChange={event => handleChangeDate(event, 'startDate')}
                keyboardIcon={
                  <StyledSVG
                    width={16}
                    height={16}
                    color='#ADB8CC'
                    src={CalendarSVG}
                  />
                }
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
                onError={error => {
                  setDateErrors(prev => error)
                }}
              />
            </div>
            <div className={classes.input_date}>
              <h1>Data final</h1>
              <KeyboardDatePicker
                variant='inline'
                minDate={exportModal.startDate}
                minDateMessage='A data final deve ser superior à data inicial'
                maxDate={new Date()}
                maxDateMessage='A data deve ser inferior ao dia atual.'
                disableToolbar
                autoOk
                inputVariant='outlined'
                invalidDateMessage='Data inválida.'
                InputAdornmentProps={{ position: 'start' }}
                format='DD/MM/yyyy'
                margin='normal'
                value={exportModal.endDate ? moment(exportModal.endDate) : null}
                onChange={event => handleChangeDate(event, 'endDate')}
                keyboardIcon={
                  <StyledSVG
                    width={16}
                    height={16}
                    color='#ADB8CC'
                    src={CalendarSVG}
                  />
                }
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
                onError={error => {
                  setDateErrors(prev => error)
                }}
              />
            </div>
          </MuiPickersUtilsProvider>
          <div className={classes.btns_modal}>
            <Button
              className={`${classes.root_btn_modal} ${classes.cancel_btn}`}
              variant='outlined'
              onClick={() => {
                handleCloseExportModal()
              }}
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.root_btn_modal} ${classes.confirm_btn}`}
              disabled={
                !moment(exportModal.startDate).isValid() ||
                !moment(exportModal.endDate).isValid() ||
                !isEmpty(dateErrors)
              }
              onClick={() => {
                handleConfirmExport()
              }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>
    </Grid>
  )
}

const mapStateToProps = (state, props) => {
  return {
    school_config: state.school.school_config,
    private_rooms: state.chats.privateRooms,
    group_rooms: state.chats.groupRooms,
    mediation_rooms: state.chats.mediationRooms,
    archived_rooms: state.chats.archivedRooms,
    currentUser: state.auth.user.data,
    rooms_reducer: state.chats,
    isFetchingRoom: state.chats.isFetching,
    currentRoom: state.chats.currentItem,
    userOccupations: state.auth.currentOccupation,
    room_menu: state.room_menu
  }
}

const mapDispatchToProps = dispatch => ({
  getChats: data => dispatch(getChatsThunk(data)),
  getChatById: data => dispatch(getChatById(data)),
  createMessageRSPA: data => dispatch(createMessageRSPA.request(data)),
  editMessageRSPA: data => dispatch(editMessageRSPA.request(data)),
  deleteMessageRSPA: data => dispatch(deleteMessageRSPA.request(data)),
  createChatRSPA: data => dispatch(createChatRSPA.request(data)),
  clearPrivateRooms: () => dispatch(clearPrivateRooms()),
  deleteChat: data => dispatch(deleteChat(data)),
  clearGroupRooms: () => dispatch(clearGroupRooms()),
  clearMediationRooms: () => dispatch(clearMediationRooms()),
  clearArchivedRooms: () => dispatch(clearArchivedRooms()),
  getRoomsRSPA: data => dispatch(getRoomsRSPA.request(data)),
  getMessagesRSPA: data => dispatch(getMessagesRSPA.request(data)),
  getInterventionMessagesRSPA: data =>
    dispatch(getInterventionMessagesRSPA.request(data)),
  showAlertMessage: (message, type) =>
    dispatch(
      showAlertMessage({
        message,
        severity: type
      })
    ),
  setRoomMenuDestination: data => dispatch(setRoomMenuDestination(data)),
  setRoomMenuType: data => dispatch(setRoomMenuType(data)),
  setArchivedType: data => dispatch(setArchivedType(data)),
  exportMessagesRSPA: data => dispatch(exportMessagesRSPA.request(data)),
  editRoomRSPA: data => dispatch(editRoomRSPA.request(data)),
  updateGroupRoomReducer: data => dispatch(updateGroupRoomReducer(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(NewMessagesPage)
